import { render, staticRenderFns } from "./YesterdayApp.vue?vue&type=template&id=4a6f6304&scoped=true"
import script from "./YesterdayApp.vue?vue&type=script&lang=js"
export * from "./YesterdayApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6f6304",
  null
  
)

export default component.exports